import { ButtonPrimeReact, DropdownPrimeReact } from "@finanedi.es/storybook"
import { withFormik } from "formik"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const NivelLogisticoAlbaran = ({
  values,
  setFieldValue,
  handleSubmit,
  onHide,
}: {
  values: { nivel: number }
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
  handleSubmit: () => void
  onHide: () => void
}) => {
  const { t } = useTranslation()

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='tw-mb-2'>
        <div className='tw-mb-4 tw-flex tw-flex-col'>
          <label htmlFor='formaPago'>
            {t("crear.facturaRec.modal.albaranLevelTitle")}
          </label>

          <DropdownPrimeReact
            options={[
              { label: "Nivel 2", id: 2 },
              { label: "Nivel 3", id: 3 },
            ]}
            value={values?.nivel}
            onChange={(e) => {
              setFieldValue("nivel", e.target.value)
            }}
            optionLabel='label'
            optionValue='id'
          />
        </div>
      </div>
      <div className='tw-mt-4 tw-flex tw-h-10 tw-flex-row tw-justify-end tw-items-center'>
        <ButtonPrimeReact
          className='tw-mr-3 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer hover:!tw-shadow'
          onClick={onHide}
        >
          {t("crear.facturaRec.modal.cancelButton")}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          type='submit'
          className='!tw-bg-primary tw-h-10 tw-flex tw-justify-center tw-items-center hover:!tw-shadow hover:!tw-bg-primary-over'
        >
          {t("crear.facturaRec.modal.addButton")}
        </ButtonPrimeReact>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  nivel: Yup.number().required(),
})

const FormNivelLogisticoAlbaran = withFormik({
  validationSchema: validate,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mapPropsToValues: ({
    intialData,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any) => {
    return {
      nivel: intialData,
    }
  },
  validateOnMount: true,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit: (values, { props }: $TSMigrationFixMe) => {
    props.onChange(values)
    props.onHide()
  },
})(NivelLogisticoAlbaran)

export default FormNivelLogisticoAlbaran
